import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useDisclosure,
  useToast,
  VStack,
} from "@chakra-ui/react";

import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useDropzone } from "react-dropzone";
import { BsChevronDown } from "react-icons/bs";
import { FaEllipsisH } from "react-icons/fa";
import { RiSearch2Line } from "react-icons/ri";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import TrDashboardHeader from "../../../components/common/TrainerDashboardHeader";
import TrainerSidenav from "../../../components/trainer/courses/Sidenav";
import { UploadCourseResultModal } from "../../../components/trainer/courses/UploadCourseResultModal";
import { UploadProgramResultModal } from "../../../components/trainer/courses/UploadProgramResultModal";
import rarrow from "../../../img/rarrow.svg";
import UserAdminService from "../../../services/admin/admin_users.service";
import { getLocalUserProfile } from "../../../services/auth.service";
import coursesService from "../../../services/courses.service";
import trainercoursesService from "../../../services/trainer/trainercourses.service";
import userService from "../../../services/user.service";
import { getFullDate, getFullTime } from "../../../utils/classOfDegree";
import trainerRoutes from "../routes";

export const ExcelDataExportCourse = [
  {
    "S/N": "1",
    "TRAINEE CODE": "",
    "ENROLLMENT CODE": "",
    "PROGRAM CODE": "",
    "MODULE CODE": "",
    "COURSE CODE": "",
    CA1: "15",
    CA2: "14",
    EXAM1: "85",
    EXAM2: "70",
    "TOTAL SCORE": "100",
    "MAX SCORE": "100",
  },
];

export const ExcelDataExportModule = [
  {
    "S/N": "1",
    "TRAINEE CODE": "",
    "ENROLLMENT CODE": "",
    "PROGRAM CODE": "",
    "MODULE CODE": "",
    CA1: "15",
    CA2: "14",
    EXAM1: "85",
    EXAM2: "70",
    "TOTAL SCORE": "100",
    "MAX SCORE": "100",
  },
];

const TrainerResult = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const { sponsor_id } = useParams();
  const [fileName, setFilename] = useState<string>("");
  const [batchFile, setbatchFile] = useState<File | null>(null);
  const [isResult, setIsResult] = useState(false);
  const [courseSession, setCourseSession] = useState<number>();
  const [courseTerm, setCourseTerm] = useState<number>();
  const [courseId, setCourseId] = useState<number>();
  const [availablecourseId, setAvailableCourseId] = useState<string>();
  const [userId, setUserId] = useState<number>();
  const [isProgram, setIsProgram] = useState<boolean>(false);
  const params = useParams();
  const course_id: any = params.course_id;
  const courseName: null | string = localStorage.getItem("courseName");
  const courseResultModalDisclosure = useDisclosure();
  const programResultModalDisclosure = useDisclosure();
  const [results, setResults] = useState<any>([]);
  const [filteredResults, setFilteredResults] = useState<any>(null);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isAvailable, setIsAvailable] = useState<boolean>(true);
  const [reload, setReload] = useState(false);

  const showSideNav = useBreakpointValue({ base: false, md: true, lg: true });
  const isSmall = useBreakpointValue({ base: true, md: false });
  const isTab = useBreakpointValue({
    base: true,
    sm: true,
    md: false,
    lg: false,
  });

  const menuLinks = [
    {
      text: "Course Information",
      route: trainerRoutes.trainerCourses.CourseInformationLink(course_id),
      keywords: ["course-information"],
    },
    {
      text: "Announcements",
      route: trainerRoutes.trainerCourses.AnnouncementLink(course_id),
      keywords: ["announcement"],
    },
    {
      text: "My trainees",
      route: trainerRoutes.trainerCourses.TraineesLink(course_id),
      keywords: ["trainees", "my-attendance-list"],
    },
    {
      text: "Event Scheduler",
      route: trainerRoutes.trainerCourses.CalendarLink(course_id),
      keywords: ["calendar"],
    },
    {
      text: "Discussions",
      route: trainerRoutes.trainerCourses.DiscussionLink(course_id),
      keywords: ["discussion", "discussions"],
    },
    {
      text: "Assessments",
      route: trainerRoutes.trainerCourses.AssignmentsLink(course_id),
      keywords: ["assessments", "assignment"],
    },
    {
      text: "Results",
      route: trainerRoutes.trainerCourses.ResultLink(course_id),
      keywords: ["results", "result"],
    },
    {
      text: "Resources",
      route: trainerRoutes.trainerCourses.ResourcesLink(course_id),
      keywords: ["resource", "resources"],
    },
  ];

  const activeLink = (link: string, keywords: string[]) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (keywords.some((keyword) => location.pathname.includes(keyword))) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };

  useEffect(() => {
    trainercoursesService.getUploadedResults().then((res) => {
      Promise.all(
        res.filter((each: any) => {
          return each.course_id === courseId;
        })
      )
        .then((updatedResults) => {
          setResults(updatedResults);
          setFilteredResults(updatedResults);
        })
        .finally(() => {
          setLoading(false);
        });
    });
  }, [reload, courseId]);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredResults(results);
    } else {
      if (results) {
        const filtered = results.filter((each: any) =>
          each.course_name.toLowerCase().includes(searchTerm)
        );
        setFilteredResults(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  const reloadData = () => {
    setReload(!reload);
  };

  useEffect(() => {
    coursesService
      .getAvailableCourses()
      .then((response) => {
        const available_course = response.find(
          (each) => each.course.uuid === course_id
        );

        console.log(available_course, "available course");

        if (available_course?.course.is_program === 1) {
          setIsProgram(true);
        } else {
          setIsProgram(false);
        }

        if (available_course) {
          setCourseSession(available_course.session_id);
          setCourseTerm(available_course.term_id);
          setCourseId(available_course.course_id);
          setAvailableCourseId(available_course.id.toString());
        } else {
          setIsAvailable(false);
        }
      })
      .catch((err) => err);
    const user = getLocalUserProfile();
    if (user) setUserId(user.id);
  }, []);

  const openUploadResult = async () => {
    // display different modal for course and program
    if (isAvailable) {
      if (isProgram) {
        console.log("na program be this");
        programResultModalDisclosure.onOpen();
      } else {
        courseResultModalDisclosure.onOpen();
      }
    } else {
      toast({
        title: "Course Unavailable",
        description: "You cannot upload result for this course",
        status: "info",
        duration: 2000,
      });
    }
  };

  const handleResultUpdate = (id: number | string, each: any) => {
    // navigate to new page
    // populate with result details
    // new page should have endpoint to update result

    navigate(trainerRoutes.trainerCourses.UpdateResultLink(course_id, id), {
      state: { resultDetails: each, programBool: isProgram },
    });
  };

  const downloadTemplate = () => {
    UserAdminService.downloadTemplate(availablecourseId)
      .then((res) => {
        // setTemplateData(res);
        const staticFilename = "Result Template"; // Replace "your_static_filename" with your desired filename
        const outputFilename = `${staticFilename}.xlsx`;

        const url = URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", outputFilename);
        document.body.appendChild(link);
        link.click();

        // Clean up the URL and link
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast({
          title: "Template Download",
          description: "Template downloaded successfully",
          status: "success",
          duration: 2000,
        });
      })
      .catch((err: any) => {
        toast({
          title: "Template Download",
          description: `${err.response.data.message}`,
          status: "error",
          duration: 2000,
        });
      });
  };
  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "30px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "white",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (!acceptedFiles.length) {
      toast({
        title: "File Upload",
        description: "Invalid file uploaded",
        status: "error",
      });
      setbatchFile(null);
    } else {
      const formData = new FormData();
      const file = acceptedFiles[0];

      formData.append("template", file);
      setbatchFile(file);
      setFilename(file.name);
      toast({
        title: "File Upload",
        description: "Your file is ready for upload",
        status: "success",
      });
    }
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop });
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box width="100hw">
          <TrDashboardHeader />
          <Box
            bg="#F9F8F8"
            minHeight="100vh"
            height="auto"
            width="100%"
            pt={"1.5rem"}
          >
            {!showSideNav && (
              <HStack
                overflowX="scroll"
                width={"100vw"}
                height={"60px"}
                justifyContent={"space-around"}
                alignItems={"center"}
                fontSize={"13px"}
                padding={"0px 10px"}
                bg="white"
                className="scroll-hidden"
                mt="1.38rem"
                // flex={"no-wrap"}
              >
                {menuLinks.map((link, index) => (
                  <React.Fragment key={index}>
                    <Link
                      onClick={() => navigate(link.route)}
                      cursor={"pointer"}
                      textAlign={"center"}
                      alignContent={"center"}
                      wordBreak={"keep-all"}
                      height={"60px"}
                      width={"max-content"}
                      borderBottom={
                        activeLink(link.route, link.keywords).borderLeft
                      }
                      borderColor={
                        activeLink(link.route, link.keywords).borderColor
                      }
                      color={activeLink(link.route, link.keywords).textColor}
                    >
                      {link.text}
                    </Link>
                    {index < menuLinks.length - 1 && (
                      <Divider orientation="vertical" height="70%" />
                    )}
                  </React.Fragment>
                ))}
              </HStack>
            )}
            <Flex
              width="90%"
              mx="auto"
              pb="120px"
              pt={["50px", "60px", "60px", "80px"]}
              boxSizing="border-box"
            >
              {showSideNav && <TrainerSidenav />}

              <VStack
                minWidth={{ lg: "80%", md: "70%", sm: "95%", base: "95%" }}
                overflowX={"scroll"}
                className="scroll-hidden"
                mr="auto"
                boxSizing="border-box"
              >
                <HStack width={"100%"} height={"2rem"} mr="auto">
                  <Text
                    as="span"
                    fontSize={["16px", "20px"]}
                    isTruncated
                    maxWidth={["180px", "200px", "350px", "500px"]}
                  >
                    {courseName && courseName.replaceAll(/"/g, "")}
                  </Text>
                  <Image src={rarrow} />
                  <Text as="span" fontSize={["16px", "20px"]} color={"#616161"}>
                    Result(s)
                  </Text>
                </HStack>

                <Box
                  width={"100%"}
                  mx="auto"
                  pb={{
                    lg: "200px",
                    md: "150px",
                    sm: "110px",
                    base: "110px",
                  }}
                  px={{
                    lg: "2.8rem",
                    md: "2.4rem",
                    sm: "2rem",
                    base: "1.4rem",
                  }}
                  pt={{ lg: "3rem", md: "2.6rem", sm: "2rem", base: "2rem" }}
                  bg="white"
                >
                  <HStack
                    width="100%"
                    bg="white"
                    pb="10px"
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                  >
                    <Text
                      color="#1E1E1E"
                      fontSize={{
                        lg: "28px",
                        md: "20px",
                        sm: "18px",
                        base: "18px",
                      }}
                      pb={["20px", "30px"]}
                      fontWeight="600"
                    >
                      Uploaded Result(s){" "}
                    </Text>

                    <HStack
                      justifyContent={"flex-end"}
                      display={["none", "none", "flex", "flex"]}
                    >
                      <Button
                        title="upload result"
                        onClick={() => {
                          openUploadResult();
                        }}
                        borderRadius={"2px"}
                        colorScheme="red"
                        size="sm"
                        width={"6rem"}
                        p="7px"
                      >
                        Add New
                      </Button>
                      <Button
                        title="download template for module"
                        variant={"outline"}
                        onClick={() => {
                          downloadTemplate();
                        }}
                        borderRadius={"2px"}
                        p="7px"
                        colorScheme="red"
                        size="sm"
                      >
                        Download template
                      </Button>
                    </HStack>
                  </HStack>
                  <Box
                    bg="transparent"
                    height="100%"
                    pt="20px"
                    pl="0px"
                    pr="0px"
                  >
                    <VStack
                      justifyContent="space-between"
                      alignItems="flex-start"
                      pb="26px"
                    >
                      <HStack gap="1rem" w={"100%"}>
                        <InputGroup
                          color="brand.subtitle"
                          bg="white"
                          width="40%"
                        >
                          <Input
                            height="40px"
                            placeholder="Search results by course/program"
                            onChange={(e) => handleSearchChange(e)}
                            fontSize={12}
                            size="sm"
                          />

                          <InputRightElement
                            pointerEvents="none"
                            children={
                              <RiSearch2Line color="red" size="0.9rem" />
                            }
                          />
                        </InputGroup>
                        <HStack justifyContent={"flex-end"}>
                          {!isSmall && (
                            <Menu>
                              <MenuButton
                                as={Button}
                                rightIcon={<BsChevronDown />}
                                bg="white"
                                color="#616161"
                                variant={"outline"}
                                size="sm"
                                height={"38px"}
                                fontSize={13}
                                border="1px solid"
                                borderColor="#9E9E9E"
                                borderRadius={"none"}
                              >
                                Sort by
                              </MenuButton>
                              <MenuList fontSize={12}>
                                <MenuItem>2022/2023</MenuItem>
                                <MenuItem>2021/2022</MenuItem>
                                <MenuItem>2020/2021</MenuItem>
                                <MenuItem>2019/2020</MenuItem>
                              </MenuList>
                            </Menu>
                          )}

                          {isTab && (
                            <Menu>
                              <MenuButton
                                as={Button}
                                rightIcon={<BsChevronDown />}
                                bg="white"
                                color="#616161"
                                variant={"outline"}
                                size="sm"
                                height={"38px"}
                                fontSize={13}
                                border="1px solid"
                                borderColor="#9E9E9E"
                                borderRadius={"none"}
                              >
                                Actions
                              </MenuButton>
                              <MenuList fontSize={12}>
                                <MenuItem
                                  onClick={() => {
                                    downloadTemplate();
                                  }}
                                >
                                  Download Template
                                </MenuItem>
                                <MenuItem
                                  onClick={() => {
                                    openUploadResult();
                                  }}
                                >
                                  Upload Results
                                </MenuItem>
                              </MenuList>
                            </Menu>
                          )}
                        </HStack>
                      </HStack>
                    </VStack>

                    {loading ? (
                      <Loading />
                    ) : (
                      <TableContainer
                        mt={5}
                        mb="100px"
                        overflowX={"scroll"}
                        className="scroll-hidden"
                        width={"100%"}
                        position={"relative"}
                      >
                        <Table variant="simple">
                          <Thead>
                            <Tr>
                              {/* <Th>Result Uploaded</Th> */}
                              <Th>Status</Th>
                              <Th>Uploaded</Th>
                              <Th>Last Modified</Th>
                              <Th>Actions</Th>
                            </Tr>
                          </Thead>

                          {results !== null && results.length > 0 && (
                            <Tbody>
                              {filteredResults.map(
                                (each: any, index: number) => (
                                  <Box
                                    key={index}
                                    as="tr"
                                    marginBottom="2px"
                                    background="white"
                                  >
                                    {/* <Td
                                      maxW="200px"
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                    >
                                      {each?.course_name
                                        ? each.course_name
                                        : "Loading..."}
                                    </Td> */}
                                    <Td>
                                      {each.is_published === 0 ? (
                                        <Box
                                          bg="#F79E1B"
                                          padding="6px 10px"
                                          borderRadius="20px"
                                          width="fit-content"
                                        >
                                          <Text color="white">
                                            Pending Review
                                          </Text>
                                        </Box>
                                      ) : each.is_published === 1 ? (
                                        <Box
                                          bg="#47BD61"
                                          padding="6px 10px"
                                          borderRadius="20px"
                                          width="fit-content"
                                        >
                                          <Text color="white">Accepted</Text>
                                        </Box>
                                      ) : (
                                        <Box
                                          bg="#EC3337"
                                          padding="6px 10px"
                                          borderRadius="20px"
                                          width="fit-content"
                                        >
                                          <Text color="white">Declined</Text>
                                        </Box>
                                      )}
                                    </Td>
                                    <Td>
                                      {getFullDate(each.created_at)}{" "}
                                      {getFullTime(each.created_at)}
                                    </Td>
                                    <Td>
                                      {getFullDate(each.created_at)}{" "}
                                      {getFullTime(each.updated_at)}
                                    </Td>
                                    <Td>
                                      <Menu>
                                        <MenuButton
                                          cursor="pointer"
                                          border="1px solid"
                                          borderRadius="10px"
                                          borderColor="#E5E5E5"
                                          paddingX="10px"
                                          height="30px"
                                          title="view actions"
                                          display="flex"
                                          justifyContent="center"
                                          alignItems="center"
                                          margin="0 auto"
                                        >
                                          <Center>
                                            <FaEllipsisH
                                              color="#757575"
                                              width="100%"
                                              height="100%"
                                              display="contents"
                                            />
                                          </Center>
                                        </MenuButton>
                                        <MenuList>
                                          <MenuItem
                                            onClick={() =>
                                              handleResultUpdate(each.id, each)
                                            }
                                          >
                                            Update Result
                                          </MenuItem>
                                          {/* <MenuItem>Delete</MenuItem> */}
                                        </MenuList>
                                      </Menu>
                                    </Td>
                                  </Box>
                                )
                              )}
                            </Tbody>
                          )}
                          {results === null && results.length == 0 && (
                            <Box>
                              <Text>No Results uploaded for this course</Text>
                            </Box>
                          )}
                          {/* {
                        isSearchEmpty && 
                        <Box>
                          <Text>No Results match your search</Text>
                        </Box>
                      } */}
                        </Table>
                      </TableContainer>
                    )}
                  </Box>
                </Box>
              </VStack>
            </Flex>

            <Portal>
              {" "}
              <UploadProgramResultModal
                isOpen={programResultModalDisclosure.isOpen}
                onClosed={programResultModalDisclosure.onClose}
                session={courseSession}
                term={courseTerm}
                ID={courseId}
                course_id={course_id}
                reload={reloadData}
              />{" "}
            </Portal>
            <Portal>
              {" "}
              <UploadCourseResultModal
                isOpen={courseResultModalDisclosure.isOpen}
                onClosed={courseResultModalDisclosure.onClose}
                session={courseSession}
                term={courseTerm}
                ID={courseId}
                course_id={course_id}
              />{" "}
            </Portal>
          </Box>
        </Box>
      )}
    </>
  );
};

export default TrainerResult;
